import React, { useEffect } from 'react';
import Filters from './Filters';
import Results from './Results';
import $ from 'jquery'
import initFilters from './includes/jquery-filters';
window.jquery = window.$ = $



export default function () {
    
    useEffect(() => {
        if($){
            initFilters();
         }
       },[$])

    return [
        <Filters
            key="filters"
        />,
        <Results
            key="results"
        />
    ];
}
